import { Component } from "react";
import { Row, Col, Button, Input, Label, Modal, ModalBody } from 'reactstrap';
import { buildCorporateMasterFilterPayload, getSelectedCorporatesFromFilter } from '../helper';
import '../style.css';

class CorporateMasterListFilterFrom extends Component {
    state = {
        selectedCorporates: [],
        salesAssociates: '',
        salesAssociatesEmail: '',
        teamLeader: '',
        region: '',
        corporateSearch: '',
        filteredCorporates: [],
        showDropdown: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            const selectedCorporates = getSelectedCorporatesFromFilter(
                this.props.currentFilters,
                this.props.corporates
            );

            this.setState({
                selectedCorporates,
                salesAssociates: this.props.currentFilters?.salesAssociates || '',
                salesAssociatesEmail: this.props.currentFilters?.salesAssociatesEmail || '',
                teamLeader: this.props.currentFilters?.teamLeader || '',
                region: this.props.currentFilters?.region || '',
                corporateSearch: '',
                filteredCorporates: this.props.corporates,
                showDropdown: false,
            });
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleCorporateSearch = (e) => {
        const search = e.target.value;
        this.setState({
            corporateSearch: search,
            filteredCorporates: this.getAvailableCorporatesForSelection(this.state.selectedCorporates, search),
            showDropdown: true,
        });
    };

    handleCorporateFocus = () => {
        this.setState({
            filteredCorporates: this.getAvailableCorporatesForSelection(
                this.state.selectedCorporates,
                this.state.corporateSearch
            ),
            showDropdown: true,
        });
    };

    getAvailableCorporates = (search = '') => {
        return this.getAvailableCorporatesForSelection(this.state.selectedCorporates, search);
    };

    handleCorporateSelect = (corporate) => {
        this.setState((prevState) => {
            const selectedCorporates = [...prevState.selectedCorporates, corporate];
            return {
                selectedCorporates,
                corporateSearch: '',
                filteredCorporates: this.getAvailableCorporatesForSelection(selectedCorporates, ''),
                showDropdown: true,
            };
        });
    };

    handleRemoveCorporate = (corporateId) => {
        this.setState((prevState) => {
            const selectedCorporates = prevState.selectedCorporates.filter((c) => c.id !== corporateId);
            return {
                selectedCorporates,
                filteredCorporates: this.getAvailableCorporatesForSelection(
                    selectedCorporates,
                    prevState.corporateSearch
                ),
            };
        });
    };

    getAvailableCorporatesForSelection = (selectedCorporates, search = '') => {
        const searchTerm = search.toLowerCase();
        return this.props.corporates.filter((c) => {
            const matchesSearch =
                !searchTerm ||
                c.name.toLowerCase().includes(searchTerm) ||
                c.id.toString().includes(search);
            const isSelected = selectedCorporates.some((selected) => selected.id === c.id);
            return matchesSearch && !isSelected;
        });
    };

    handleApply = () => {
        this.props.onApply(
            buildCorporateMasterFilterPayload({
                selectedCorporates: this.state.selectedCorporates,
                salesAssociates: this.state.salesAssociates,
                salesAssociatesEmail: this.state.salesAssociatesEmail,
                teamLeader: this.state.teamLeader,
                region: this.state.region,
            })
        );
    };

    handleReset = () => {
        this.setState({
            selectedCorporates: [],
            salesAssociates: '',
            salesAssociatesEmail: '',
            teamLeader: '',
            region: '',
            corporateSearch: '',
            filteredCorporates: this.props.corporates,
            showDropdown: false,
        }, () => {
            this.props.onApply(
                buildCorporateMasterFilterPayload({
                    selectedCorporates: [],
                    salesAssociates: '',
                    salesAssociatesEmail: '',
                    teamLeader: '',
                    region: '',
                })
            );
        });
    };

    renderFilterField = (label, name, value, placeholder, type = 'text') => (
        <Col sm="12" className="corporate-master-filter-field">
            <div className="corporate-master-filter-row">
                <Label className="corporate-master-filter-label">{label}</Label>
                <Input
                    type={type}
                    name={name}
                    value={value}
                    onChange={this.handleChange}
                    placeholder={placeholder}
                    className="corporate-master-filter-input-wrap"
                    style={{ height: type === 'select' ? '38px' : '38px' }}
                />
            </div>
        </Col>
    );

    renderCorporateDropdown = () => {
        const { corporates, corporatesLoading } = this.props;
        const { selectedCorporates, corporateSearch, showDropdown } = this.state;
        const filteredCorporates = showDropdown ? this.getAvailableCorporates(corporateSearch) : [];

        return (
            <Col sm="12" className="corporate-master-corporate-field">
                <div className="corporate-master-corporate-input-row">
                    <Label className="corporate-master-filter-label">Corporate Name:</Label>
                    <div className="corporate-master-filter-input-wrap position-relative">
                        <Input
                            type="text"
                            placeholder="Enter corporate name"
                            value={corporateSearch}
                            onChange={this.handleCorporateSearch}
                            onFocus={this.handleCorporateFocus}
                            onBlur={() => setTimeout(() => this.setState({ showDropdown: false }), 200)}
                            disabled={corporatesLoading || corporates.length === 0}
                            style={{ height: '38px' }}
                        />

                        {showDropdown && filteredCorporates.length > 0 && (
                            <ul className="dropdown-menu show corporate-master-corporate-dropdown">
                                {filteredCorporates.map((c) => (
                                    <li
                                        key={c.id}
                                        className="dropdown-item"
                                        style={{ cursor: 'pointer' }}
                                        onMouseDown={() => this.handleCorporateSelect(c)}
                                    >
                                        {c.name} ({c.id})
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {selectedCorporates.length > 0 && (
                    <div className="corporate-master-selected-chips">
                        {selectedCorporates.map((c) => (
                            <span key={c.id} className="corporate-master-selected-chip">
                                {c.name} ({c.id})
                                <button
                                    type="button"
                                    className="corporate-master-selected-chip-remove"
                                    aria-label="Remove"
                                    onClick={() => this.handleRemoveCorporate(c.id)}
                                >
                                    &times;
                                </button>
                            </span>
                        ))}
                    </div>
                )}
            </Col>
        );
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { salesAssociates, salesAssociatesEmail, teamLeader, region } = this.state;

        return (
            <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
                <ModalBody>
                    <Row className="mb-2">
                        {this.renderCorporateDropdown()}
                        {this.renderFilterField('Sales Associate:', 'salesAssociates', salesAssociates, 'Enter Sales Associate')}
                        {this.renderFilterField('Email:', 'salesAssociatesEmail', salesAssociatesEmail, 'Enter Email')}
                    </Row>

                    <Row className="mb-4">
                        {this.renderFilterField('Team Leader:', 'teamLeader', teamLeader, 'Enter Team Lead')}
                        <Col sm="12" className="corporate-master-filter-field">
                            <div className="corporate-master-filter-row region-filter-row">
                                <Label className="corporate-master-filter-label">Region:</Label>
                                <Input
                                    type="select"
                                    name="region"
                                    value={region}
                                    onChange={this.handleChange}
                                    className="corporate-master-filter-input-wrap"
                                    style={{ height: '38px' , marginTop: '-5px' }}
                                >
                                    <option value="">Select Region</option>
                                    <option value="South">South</option>
                                    <option value="West">West</option>
                                    <option value="East">East</option>
                                    <option value="North">North</option>
                                    <option value="Central">Central</option>
                                    <option value="Management">Management</option>
                                    <option value="Central Accounts">Central Accounts</option>
                                </Input>
                            </div>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-between flex-wrap">
                        <div className="d-flex mb-2 mb-sm-0">
                            <Button outline color="primary" onClick={toggle}>
                                Hide Filters
                            </Button>

                            <Button
                                outline
                                color="primary"
                                className="ml-2"
                                onClick={this.handleReset}
                            >
                                Reset Filters
                            </Button>
                        </div>

                        <Button color="primary" onClick={this.handleApply}>
                            Apply
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default CorporateMasterListFilterFrom;
